module.exports = __webpack_public_path__ + "img/p8_4.d4abb2f1.png";